export const contentTableConfig = {
  title: '直播间列表',
  propList: [
    {
      prop: 'eventName',
      label: '直播间',
      minWidth: '100',
      slotName: 'name',
      align: 'left'
    },
    {
      prop: 'liveUrl',
      label: '打开直播间',
      minWidth: '80',
      slotName: 'liveUrl'
    },
    { prop: 'id', label: '复制链接', minWidth: '80', slotName: 'generate' },
    {
      label: '操作',
      minWidth: '80',
      slotName: 'handler'
    }
  ],
  showIndexColumn: false,
  showSelectColumn: false
}
